import { UpdatePasswordPageProps, useTranslate } from '@refinedev/core'
import { CardProps, Form, FormProps, LayoutProps, Typography } from 'antd'
import React from 'react'
import { useSearchParams } from 'react-router-dom'
import { useGetEmailByCode } from '../../../../api'
// import { ReactComponent as SmartLogo } from '../../../../common/images/svg/SmartIcon.svg'
import { ReactComponent as SmartLogo } from '../../../../common/images/svg/SmartIconHover.svg'
import { CustomButton } from '../../../../components/button/buttonCustom'
import LoadingOverlay from '../../../../components/loading/loadingOverlay'
import useAuth from '../../../../utils/hooks/useAuth'
import useResponsive from '../../../../utils/hooks/useResponsive'
import { ThemedTitle } from '../../../themedLayout/title'
import { ConfirmPasswordForms } from './confirmPasswordForms'
import { PageDescriptionStyles, PageTitleStyles } from './styles'

const QUERY_PARAM_NAME = 'code'

type UpdatePasswordFormTypes = {
  password: string
  confirm: string
  code: string | null
}
type UpdatePasswordProps = UpdatePasswordPageProps<
  LayoutProps,
  CardProps,
  FormProps
>

export const ResetPasswordPage: React.FC<
  UpdatePasswordProps & { description?: React.ReactNode }
> = ({ formProps, title, description }) => {
  const [form] = Form.useForm<UpdatePasswordFormTypes>()
  const translate = useTranslate()
  const { isTablet } = useResponsive()
  const requiredFields = ['password', 'confirm']

  const [isAllFieldsFilled, setIsAllFieldsFilled] = React.useState(false)
  const [searchParams] = useSearchParams()
  const code = searchParams.get(QUERY_PARAM_NAME)

  const { data: email = { data: { data: '' } } } = useGetEmailByCode(code || '')

  const { resetPassword, loadingResetPassword } = useAuth()

  const onFinish = (values: UpdatePasswordFormTypes, code: string | null) => {
    const { confirm, ...rest } = values
    resetPassword({ ...rest, code })
  }

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo)
  }

  const checkAllFieldsFilled = () => {
    const values = form.getFieldsValue(requiredFields as any)
    return requiredFields.every((field) => !!values[field])
  }

  const PageTitle =
    title === false ? null : (
      <div style={{ ...PageTitleStyles }}>
        {title ?? <ThemedTitle collapsed={false} />}
      </div>
    )

  const Description =
    description === false ? null : (
      <Typography style={{ ...PageDescriptionStyles }}>
        {`You’re resetting the password for ${email.data.data}. Please enter a new one.`}
      </Typography>
    )

  const CardContent = (
    <Form
      style={{ width: '100%' }}
      layout='vertical'
      form={form}
      requiredMark={false}
      {...formProps}
      onFinish={(values) => onFinish(values, code)}
      onFinishFailed={onFinishFailed}
      onValuesChange={() => {
        setIsAllFieldsFilled(checkAllFieldsFilled())
      }}>
      <div className='auth-form'>
        <ConfirmPasswordForms />
        <CustomButton
          type='submit'
          size={isTablet ? 'medium' : 'large'}
          width={'100%'}
          text={translate('pages.resetPassword.buttons.submit', 'Submit')}
          disabled={!isAllFieldsFilled}
        />
      </div>
    </Form>
  )

  return (
    <div className='auth-box'>
      <div className='auth-render'>
        {PageTitle}
        {Description}
        {CardContent}
      </div>
      <SmartLogo className='auth-logo' style={{ width: 56, height: 46 }} />
      <LoadingOverlay loading={loadingResetPassword} />
    </div>
  )
}
